import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { MegaphoneLocation, MegaphoneApiData } from "../api/megaphones";
import { Megaphone, loadMegaphones, openMegaphone, closeMegaphone, clickMegaphone } from "../actions/Megaphones";

export type MegaphonesState = { [key in MegaphoneLocation]?: Megaphone | null };

const initialState: MegaphonesState = {};

function setUpMegaphone(data: MegaphoneApiData): Megaphone {
  return {
    ...data,
    isOpened: false,
    isClosed: false,
    isClicked: false,
  };
}

const megaphonesReducer = withImmer(reducerWithInitialState(initialState))
  .case(loadMegaphones.done, (state, { result: megaphones }) => {
    Object.entries(megaphones).forEach(([location, data]) => {
      if (data) {
        state[location as MegaphoneLocation] = setUpMegaphone(data);
      }
    });
    return state;
  })
  .case(openMegaphone.done, (state, { result: location }) => {
    state[location as MegaphoneLocation]!.isOpened = true;
    return state;
  })
  .case(closeMegaphone.done, (state, { result: location }) => {
    state[location as MegaphoneLocation]!.isClosed = true;
    return state;
  })
  .case(clickMegaphone.done, (state, { result: location }) => {
    state[location as MegaphoneLocation]!.isClicked = true;
    return state;
  });

export default megaphonesReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/megaphones.ts